module.exports = __webpack_public_path__ + "static/media/leftOutlinedIcon.73bf31fc.svg";